// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.p_font_size[data-v-48c07917] li {\n\n  text-indent: -22px;\n  padding-left: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
